import React from "react";
import SitemapSection from "../components/Sitemap/Sitemap.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const Sitemap = () => {
  return (
    <div>
      <MetaComponent
        title="Sitemap"
        desc=""
        keywords=""
      />
      <SitemapSection />
    </div>
  );
};

export default Sitemap;
